import HarmonyWithIqos from './HarmonyWithIqos';
export default HarmonyWithIqos;